<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    data: function(){
        return {
            dropupOpen: false,
            selected: 1
        }

    },

    computed: {
       
    },
    methods: {
        toggleOpen: function() {
          this.dropupOpen = !this.dropupOpen;
        },
        close: function() {
            this.dropupOpen = false
        }
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/apps/dropup.vue